import React from "react";
import { Helmet } from "react-helmet";
import AppLayoutTitle from "./appLayoutTitle";
import { handleException } from "../../helper/helperError";
import { apiPost } from "../../helper/helperApi";
import { isEmpty } from "../../helper/helperGeneral";
import Swal from "sweetalert2";
import { getFCMToken, messaging, onMessage } from "../../helper/helperFirebaseMessaging";
import { apiGet } from './../../helper/helperApi';


const AppAdminTools = () => {
    React.useEffect(() => {
        onMessage(messaging, (payload) => {
            Swal.fire(
                payload?.notification?.title ?? "TITLE",
                payload?.notification?.body ?? {}
            );
        });
    }, []);

    const handleRegister = async () => {
        try {
            // 1- Request permission
            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                throw new Error("Permission not granted");
            }

            // 2- Get FCM token
            const fcmToken = await getFCMToken();
            if (isEmpty(fcmToken)) throw new Error("Failed to get FCM token");

            // 3- Send the subscription request
            await apiPost("/notification/subscribe", {
                token: fcmToken,
            });
            Swal.fire({
                title: "Success",
                text: "Subscribed to notifications.",
                icon: "success",
                timer: 1500,
            });
        } catch (ex) {
            handleException(ex, "Failed to register for notifications");
        }
    };

    const handleWhitelistDomains = async () => {
        try {
            // 1- Get the whitelisted domains
            const result = await apiGet("/domains/freshWhitelist");
            const whitelistDomains = result?.data;
            if (isEmpty(whitelistDomains)) throw new Error("Failed to get whitelisted domains");

            // 2- Show the whitelisted domains
            const domainText = whitelistDomains?.map((wd) => `${wd.name}`)?.join(", ");
            Swal.fire({
                title: "Whitelisted Domains",
                html: `${whitelistDomains?.length} whitelisted domains found:<br/>${domainText}`,
                icon: "info",
                confirmButtonText: "OK",
            });


        } catch (ex) {
            handleException(ex, "Failed to get fresh whitelisted domains");
        }
    }

    return (
        <>
            <Helmet>
                <title>Admin Tools | Super Admin | Sparkling Email</title>
            </Helmet>
            <>
                <AppLayoutTitle title="Tools" />
                <div className="px-3 py-3">
                    <h5>Push Notifications</h5>
                    <div>
                        Set up your profile to get notifications about sparkling
                        email.
                    </div>
                    <div>
                        You can set up your profile to get notifications about
                        sparkling email. You can set up your profile to get
                        notifications about sparkling email. You can set up your
                        profile to get notifications about sparkling email.
                    </div>
                    <br />
                    <div>
                        <button className="btn btn-dark" onClick={handleRegister}>
                            Register for notifications
                        </button>
                    </div>
                </div>
                <hr className="my-3" />
                <div className="px-3 py-3">
                    <h5>Reload & Show Whitelists Domains</h5>
                    <div>
                        Clears the cache and retrieves the latest list of whitelisted
                        domains allowed to send emails to your users. <b>You can view
                            details in the console</b>
                    </div>
                    <br />
                    <div>
                        <button className="btn btn-dark" onClick={handleWhitelistDomains}>
                            Show whitelisted domains
                        </button>
                    </div>
                </div>
            </>
        </>
    );
};
export default AppAdminTools;